import React from 'react';
import Translate from 'react-translate-component';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

const NO_TRANSLATION = ' ';

export class Ambassador extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      modalIsOpen: false
    };
  }

  renderButton = () => {
    const buttonUrl = proxyCounterpart('BECOME_CLIENT_BUTTON_URL', {fallback: NO_TRANSLATION});

    if (buttonUrl === NO_TRANSLATION) {
      return (
        <a className='btn primary' to='' onClick={this.openModal}>
          <Translate content='BECOME_CLIENT_ENTER_CONTEST'/>
        </a>
      );
    }

    return (
      <a className='btn primary' href={buttonUrl} target='_blank'>
        <Translate content='BECOME_CLIENT_ENTER_CONTEST'/>
      </a>
    );
  };

  imageUrlFromTranslations = () => {
    const imageUrl = proxyCounterpart('BECOME_CLIENT_IMAGE_URL', {fallback: NO_TRANSLATION});
    return imageUrl === NO_TRANSLATION ? null : imageUrl;
  }

  renderCtaButton = () => {
    const buttonUrl = proxyCounterpart('DASHBOARD_CTA_POST_BUTTON_URL', {fallback: NO_TRANSLATION});

    if (buttonUrl === NO_TRANSLATION) {
      return (
        <a className='btn primary' to='' onClick={''}>
          <Translate content='DASHBOARD_CTA_POST_BUTTON_TEXT'/>
        </a>
      );
    }

    return (
      <a className='btn primary' href={buttonUrl} target='_blank'>
        <Translate content='DASHBOARD_CTA_POST_BUTTON_TEXT'/>
      </a>
    );
  };

  ctaPostimageUrlFromTranslations = () => {
    const imageUrl = proxyCounterpart('DASHBOARD_CTA_POST_IMAGE_URL', {fallback: NO_TRANSLATION});
    return imageUrl === NO_TRANSLATION ? null : imageUrl;
  }

  renderCtaPost = () => {
    let imageUrl = this.ctaPostimageUrlFromTranslations();

    return (
      <div>
        <h2><Translate content='DASHBOARD_CTA_POST_TITLE' /></h2>
        <div className='client-image' style={{backgroundImage: `url(${imageUrl})`}}></div>
        <div>
          <h3><Translate content='DASHBOARD_CTA_POST_SUBTITLE' /></h3>
          <p><Translate content='DASHBOARD_CTA_POST_CONTENT' /></p>
          {this.renderCtaButton()}
        </div>
      </div>
    );
  }

  render = () => (
    <div className='col-md-6 col-md-offset-1 ambassador'>
      <div>
        {this.renderCtaPost()}
      </div>
    </div>
  );
}

export default Ambassador;



/** WEBPACK FOOTER **
 ** ./src/components/left-page-section/ambassador/ambassador.js
 **/